@if (!showAsTable) {
  @if (product && priceTiers.length > 1) {
    <div
      id="price-tiers-dropdown"
      ngbDropdown
      placement="{{ placementPosition }}"
      class="pricing-tiers--box"
    >
      <a
        id="price-tiers-toggle"
        class="dropdown-toggle no-caret ps-2 pe-2"
        ngbDropdownToggle
      >
        <i class="fal fa-info-circle"></i>
      </a>
      <div
        class="dropdown-menu dropdown-menu-right pricing-tiers__container"
        aria-labelledby="product-pricing"
        ngbDropdownMenu
      >
        <div class="dropdown-menu-content pricing-tiers">
          <strong>PRICING TIERS</strong>
          <ul>
            @for (priceTier of priceTiers; track priceTier) {
              <li [ngClass]="{ 'is-bold': priceTier.selected }">
                <span>{{ priceTier.range }}</span
                ><span>{{ priceTier.price }}</span>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
} @else {
  @if (product && priceTiers.length > 1) {
    <div>
      <strong>PRICING TIERS</strong>
      <table id="price-tiers-table" class="table">
        <thead>
          <tr>
            <th scope="col">Range</th>
            <th scope="col">Price</th>
          </tr>
        </thead>
        <tbody>
          @for (priceTier of priceTiers; track priceTier) {
            <tr>
              <td>{{ priceTier.range }}</td>
              <td>{{ priceTier.price }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
}
